import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../api/client';

const DEFAULTS = {
  promo_tiles: [],
  footer_links: {},
  brand_name: 'Dr Tools',
  tagline: ''
};

const SettingsContext = createContext({ settings: DEFAULTS, refresh: () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get('/settings');
      setSettings(res.data);
    } catch (e) { /* keep defaults */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
